export const getValidatorStoreProductId = (body = {}) => {
  const transaction = body?.transaction || {};
  const transactionType = String(transaction?.type || "").trim().toLowerCase();
  const isAppleStoreKit2 =
    transactionType === "apple-sk2" || Boolean(transaction?.jwsRepresentation);

  if (isAppleStoreKit2) {
    return String(
      transaction?.productId ||
      transaction?.product_id ||
      transaction?.id ||
      ""
    ).trim();
  }

  return String(
    body?.productId ||
    body?.product_id ||
    transaction?.productId ||
    transaction?.product_id ||
    body?.id ||
    ""
  ).trim();
};

export const buildNativeStoreValidatorSuccess = ({
  productId,
  storePlatform,
  transactionType,
  responseData = {},
  transaction = {},
} = {}) => {
  const transactionId =
    responseData?.store_transaction_id || transaction?.id || productId;
  return {
    ok: true,
    data: {
      id: productId,
      latest_receipt: true,
      transaction: {
        type: transactionType,
        id: transactionId,
      },
      collection: [
        {
          id: productId,
          platform: storePlatform,
          purchaseId: transactionId,
          transactionId,
          ...(responseData?.delivery?.store_acknowledged === true
            ? { isAcknowledged: true }
            : {}),
        },
      ],
      date: new Date().toISOString(),
    },
  };
};
